<template>
    <el-dialog :title="$t('common.add') + (misc ? ' Misc ' : ' ') + $t('common.part')" :visible.sync="showDialog" @close="closeDialog" width="500px" class="part-dialog" append-to-body :close-on-click-modal="false">
        <el-form ref="form" :model="form" :rules="rules" size="small" label-width="100px" label-position="left">
            <el-form-item :label="$t('common.part')" prop="part" v-if="!misc">
                <claim-part-selector ref="part-selector" :serviceCompanyId="currentCompanyId" :productId="productId" :isNotWarrantyClaim="isNotWarrantyClaim" @part-selected="partSelected"></claim-part-selector>
            </el-form-item>
            <el-form-item label-width="0" v-if="selectedPart">
                <ul style="margin: 0; padding: 0; list-style: none; line-height: 20px">
                    <li><b>{{$t('common.part')}}</b> {{selectedPart.name}}</li>
                    <li><b>{{$t('claims.listPrice')}}</b> {{selectedPart.price | money}}</li>
                    <li><b>{{$t('claims.extendedPrice')}}</b> {{selectedPart.extendedPrice | money}}</li>
                    <li v-if="selectedPart.needsReturn"><b>{{$t('claims.returnNeeded')}}</b> <i class="el-icon-check"></i></li>
                </ul>
            </el-form-item>

            <el-form-item :label="$t('common.name')" prop="name" v-if="misc">
                <el-input v-model="form.name"></el-input>
            </el-form-item>

            <el-form-item :label="$t('claims.price')" prop="price" v-if="misc">
                <el-input-number v-model="form.price" :min="0.01" :max="10000"></el-input-number>
            </el-form-item>
            
            <el-form-item :label="$t('common.quantity')" prop="quantity">
                <el-input-number v-model="form.quantity" :min="1" :max="1000"></el-input-number>
            </el-form-item>

            <el-form-item :label="$t('common.extendedPrice')" v-if="misc && form.price && form.quantity">
                <span>{{Number(form.price) * Number(form.quantity)}}</span>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button type="primary" @click="addPart">{{$t('common.add')}}</el-button>
            <el-button @click="closeDialog">{{$t('common.cancel')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import Vue from "vue";
    import ClaimPartSelector from "./ClaimPartSelector";
    import api from "../api";

    export default {
        name: "add-part-dialog",
        components: {
            ClaimPartSelector
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            misc: {
                type: Boolean,
                default: false
            },
            serviceCompanyId: {
                type: Number,
                required: false
            },
            productId: {
                required: true
            },
            isNotWarrantyClaim: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                form: {
                    part: undefined,
                    quantity: 1,

                    name: "",
                    price: undefined,
                    extendedPrice: undefined
                },
                rules: {
                    part: [
                        {
                            required: true,
                            message: this.$t('common.pleaseSelectPart'),
                            trigger: "change"
                        }
                    ],
                    name: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterName'),
                            trigger: "blur"
                        }
                    ],
                    price: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterPrice'),
                            trigger: "blur"
                        }
                    ],
                    extendedPrice: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterExtendedPrice'),
                            trigger: "blur"
                        }
                    ],
                    quantity: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterQuantity'),
                            trigger: "blur"
                        }
                    ]
                },
                selectedPart: undefined,
                showDialog: this.visible
            };
        },
        methods: {
            closeDialog() {
                this.selectedPart = undefined;
                this.$refs["form"].resetFields();
                if (this.$refs["part-selector"]) {
                    this.$refs["part-selector"].reset();
                }
                this.showDialog = false;
                this.$emit("dialogClosed");
            },
            partSelected(part) {
                if (part) {
                    this.form.part = part;
                    var self = this;
                    api.getPartById(part.id, this.serviceCompanyId, this.isNotWarrantyClaim).then(function (response) {
                        self.form.part = response.data;
                        self.selectedPart = response.data;
                    });
                } else {
                    this.form.part = undefined;
                    this.form.quantity = 1;
                    this.selectedPart = undefined;
                }
            },
            addPart() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        var part = this.form.part;
                        if (this.misc) {
                            part = {
                                name: this.form.name,
                                price: this.form.price,
                                extendedPrice: this.form.extendedPrice
                            };
                        }
                        this.$emit("part-added", {
                            part: part,
                            quantity: this.form.quantity
                        });
                        this.closeDialog();
                    } else {
                        return false;
                    }
                });
            }
        },
        computed: {
            currentCompanyId() {
                return this.$isAdmin ? this.serviceCompanyId : window.currentCompany.id;
            }
        },
        watch: {
            visible: function (val) {
                this.showDialog = val;
            }
        }
    };
</script>

<style scoped>
.full-width {
  width: 100%;
}

.part-dialog >>> .el-dialog__body {
  padding: 0 15px;
}
</style>


// WEBPACK FOOTER //
// ClientApp/app/claims/components/AddPartDialog.vue